import React from "react";
import { StyleProp, View, ViewStyle } from "react-native";
import { Target, useAppSelector } from "../../../store";

import { COLORS } from "../store/MixReducer";
import { ColorRectangle } from "./ColorRectangle";

export interface ColorPickerProps {
  style?: StyleProp<ViewStyle>;
  disabled?: boolean;
  target?: Target;
  onChange: (color: string) => void;
}

export const ColorPicker = ({
  style,
  disabled = false,
  target,
  onChange,
}: ColorPickerProps) => {
  const selectedColors = useAppSelector((state) => state.mix.selectedColors);
  const selectedColor = target
    ? useAppSelector((state) => state.mix[target].secret)
    : useAppSelector((state) => state.mix["generator"]);

  return (
    <View
      style={[
        style,
        {
          flexDirection: "row",
          flexWrap: "wrap",
          justifyContent: "center",
        },
      ]}
    >
      {COLORS.map((c) => (
        <View
          key={c}
          style={{
            width: "33%",
            justifyContent: "center",
            alignItems: "center",
            opacity:
              disabled || (selectedColors.includes(c) && selectedColor !== c)
                ? 0
                : 1,
          }}
        >
          <ColorRectangle
            color={c}
            disabled={disabled || selectedColor.includes(c)}
            selected={selectedColor === c}
            onPress={() => {
              if (!disabled && !selectedColors.includes(c)) {
                onChange(c);
              }
            }}
          />
        </View>
      ))}
    </View>
  );
};
